export default __webpack_public_path__ + "img/plus-original.51d8374e.svg";